<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-exchange-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'clearing-house'" [fieldId]="'clearingHouseCode'" [fieldName]="'clearingHouseCode'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [formLoading]="formLoading"
                   [writeRoles]="CCRoles.ROLES_EXCHANGE_WRITE" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-exchange-sidebar>
